import { flattenConfiguracoes, isRequiredFieldEmpty } from './cpa-grid-bridge-format.utils';

/**
 * Valida visualmente (classe `cpa-required-invalid`) e agrega a validade dos campos marcados
 * como obrigatórios (`label.required`) no cpa-grid legado, notificando o host via callback
 * (ex: `@Output() requiredFieldsValidChange`). O callback é chamado a cada avaliação,
 * independente do valor ter mudado.
 */
export class CpaRequiredValidationController {
  constructor(private readonly onValidityChange: (valid: boolean) => void) {}

  bindRequiredValidationVisualState(hostEl: HTMLElement | null | undefined): void {
    if (!hostEl) {
      return;
    }

    const labels = hostEl.querySelectorAll('label.required');
    labels.forEach((labelEl) => {
      const container = labelEl.closest('.template-field') as HTMLElement | null;
      if (!container) {
        return;
      }

      const fieldEl = container.querySelector('input, textarea, select') as HTMLElement | null;
      if (!fieldEl) {
        return;
      }

      const updateState = () => {
        const invalid = isRequiredFieldEmpty(fieldEl);
        fieldEl.classList.toggle('cpa-required-invalid', invalid);

        const fallback = container.querySelector('.cpa-select2-fallback') as HTMLElement | null;
        if (fallback) {
          fallback.classList.toggle('cpa-required-invalid', invalid);
        }

        this.emitRequiredFieldsValidity(hostEl);
      };

      if (!(fieldEl as any).__cpaRequiredBound) {
        ['input', 'change', 'blur'].forEach((evt) => {
          fieldEl.addEventListener(evt, updateState);
        });
        (fieldEl as any).__cpaRequiredBound = true;
      }

      updateState();
    });

    this.emitRequiredFieldsValidity(hostEl);
  }

  emitRequiredFieldsValidity(hostEl: HTMLElement | null | undefined): void {
    if (!hostEl) {
      return;
    }

    const labels = hostEl.querySelectorAll('label.required');
    const hasInvalidRequired = Array.from(labels).some((labelEl) => {
      const container = labelEl.closest('.template-field') as HTMLElement | null;
      if (!container) {
        return false;
      }
      const fieldEl = container.querySelector('input, textarea, select') as HTMLElement | null;
      if (!fieldEl) {
        return false;
      }
      return isRequiredFieldEmpty(fieldEl);
    });

    this.onValidityChange(!hasInvalidRequired);
  }

  annotateRequiredToggleTitles(hostEl: HTMLElement | null | undefined, scopeConfig: any): void {
    if (!hostEl) {
      return;
    }

    const toggleLabels = hostEl.querySelectorAll('.group-title-header label');
    if (!toggleLabels.length) {
      return;
    }

    const configuracoes = flattenConfiguracoes(scopeConfig);
    toggleLabels.forEach((labelEl, index) => {
      const configuracao = configuracoes[index];
      const hasRequiredField = !!configuracao?.agrupadores?.some((agrupador: any) =>
        Array.isArray(agrupador?.campos) && agrupador.campos.some((campo: any) => !!campo?.obrigatorio)
      );
      labelEl.classList.toggle('cpa-required-toggle-title', hasRequiredField);
    });
  }
}
